import { Container, Button } from "react-bootstrap";

import { floating } from "../helpers";
import { useEffect } from "react";
import { CodereHelmet } from "../../../App";
import { SPEEDSIZE_PREFIX } from "../../../App";

export default function Freebets({ flag }) {
  useEffect(() => {
    let json = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "¿Cómo funcionan las apuestas gratis en los casinos y casas de apuestas?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Las apuestas gratis ofrecen la oportunidad de ganar dinero sin arriesgar tu propio capital, sin embargo, estas tienen sus condiciones y restricciones para tal fin.",
          },
        },
        {
          "@type": "Question",
          name: "¿Puedo ganar dinero real con apuestas gratis?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Podrás liberar tus ganancias de las apuestas gratis si cumples con las restricciones. Sin embargo, ten en cuenta que las apuestas gratis son aleatorias y suelen generar un monto no retirable para multiplicar lo apostado en el evento deportivo.",
          },
        },
        {
          "@type": "Question",
          name: "¿Cuál es la diferencia entre Free Bets y las apuestas gratis?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No hay diferencia. Tanto las Free Bets como las apuestas gratis son incentivos de casas de apuestas como Codere, permitiéndote apostar sin riesgo, ya que cubren el importe de la apuesta con tu dinero real.",
          },
        },
      ],
    };

    let title = "Free Bets en tus Apuestas Online » Juega sin riesgos";
    let desc =
      "Descubre las mejores Free Bets en Codere Colombia. Disfruta de tus apuestas deportivas con promociones exclusivas. ¡Regístrate hoy y vive la experiencia!";
    let can = "https://www.codere.com.co/ayuda/free-bets";

    CodereHelmet(title, desc, can, [json]);
  }, []);

  const top_par = {
    h1: "Conoce las Free Bets o bonos de Apuestas Deportivas Gratis en Codere ",
    p: `¿Eres un apasionado de las apuestas deportivas y te encanta aprovechar cada oportunidad para ganar sin arriesgar tu bolsillo? Entonces, las Free Bets o bonos de apuestas gratis de Codere son justo lo que necesitas.\nEn este segmento te daremos a conocer qué son este tipo de bonos de apuestas gratis y cómo funcionan dentro de una apuesta deportiva en Codere. Quédate y conoce un sinfín de posibilidades, para ganar con tus eventos y deportes favoritos.`,
  };

  const p1 = {
    id: "p1",
    h2: "¿Qué son las Free Bets y para qué sirven? ",
    p: "Una “free bet” es un bono especial que cuenta con un importe de dinero específico como recompensa por la participación en una promoción o como regalo; esta puede utilizarse en apuestas pre-partido o en vivo de forma gratuita. Luego de utilizarla en tu evento deportivo, las ganancias netas serán para ti.  ",
    inner: [
      {
        h3: "Ventajas",
        p: "El beneficio es que, usando una free bet con una cuota mínima de 2.0, podrás obtener ganancias significativas si tu apuesta sale victoriosa, ya sea para aprovecharlas en una nueva apuesta o cobrarlas cumpliendo con nuestros términos y condiciones.  ",
      },
      {
        h3: "Tipos de ofertas que pueden tener las Free Bets",
        p: "Estas ofertas pueden variar en su monto según la promoción, regalo o dinámica de donde se obtuvieron. Podrán aplicar en los diferentes deportes ofrecidos en Codere bajo las modalidades tales como: Apuestas simples, apuestas combinadas o parlays y apuestas en vivo. Para esto, es fundamental consultar con más detalles los términos y condiciones de dicha promoción.",
      },
    ],
  };

  const p2 = {
    id: "p2",
    h2: "Guía de paso a paso para reclamar free bets",
    h3: "Tips para aprovechar al máximo las Free Bets y apuestas gratis",
    p: "Para reclamar tu bono de apuesta gratis, debes tener en cuenta estos factores fundamentales:",
    ol: [
      "Para obtener una free bet con Codere, puedes hacerlo de diferentes formas a través del Bono de Bienvenida de Deportes, ingresando a nuestra web en la pestaña “promociones”, o también siguiéndonos en las redes sociales oficiales gracias a las dinámicas que tenemos para ti. Recuerda que te llegará un mensaje al teléfono y correo electrónico registrados.",
      "Una vez que obtengas tu promoción, deberás asegurarte de autorizarla realizando tu verificación SMS para que puedas usarla sin ningún inconveniente.",
      "¿Cómo la usas? Tienes dos formas: por medio de nuestro botón “free bets” o directamente en tu ticket de apuesta clickeando la opción “usar mi free bet”, allí podrás elegir el monto por el cual deseas usarla.",
    ],
    ul: [
      "Lee los términos y condiciones antes de iniciar: recuerda que estas tienen una duración máxima de siete (7) días calendario, conforme a la fecha de entrega de estas.",
      "Compara y conoce las ofertas: En Codere no todos los bonos de apuestas gratis son iguales. Por eso es importante que te asegures de entender los requisitos de apuesta mínima, las cuotas mínimas, los deportes y mercados elegibles.",
      "Realizar una apuesta inteligente: Para hacer una buena apuesta, debes investigar y elegir una apuesta con buenas probabilidades de éxito. Recuerda que el objetivo es ganar dinero real, no solo utilizar la oferta por utilizarla.",
    ],
  };

  const preguntas = {
    id: "preguntas",
    h2: "FAQ (Preguntas Frecuentes)",
    inner: [
      {
        h3: "¿Cómo funcionan las apuestas gratis en los casinos y casas de apuestas?",
        p: "Las apuestas gratis ofrecen la oportunidad de ganar dinero sin arriesgar tu propio capital, sin embargo, estas tienen sus condiciones y restricciones para tal fin.",
      },
      {
        h3: "¿Puedo ganar dinero real con apuestas gratis?",
        p: "Podrás liberar tus ganancias de las apuestas gratis si cumples con las restricciones. Sin embargo, ten en cuenta que las apuestas gratis son aleatorias y suelen generar un monto no retirable para multiplicar lo apostado en el evento deportivo.",
      },
      {
        h3: "¿Cuál es la diferencia entre Free Bets y las apuestas gratis?",
        p: "No hay diferencia. Tanto las Free Bets como las apuestas gratis son incentivos de casas de apuestas como Codere, permitiéndote apostar sin riesgo, ya que cubren el importe de la apuesta con tu dinero real.",
      },
    ],
  };

  return (
    <div className="codere-green">
      {floating("aumenta la emoción")}
      <div
        className="top-bg-seo "
        style={{
          backgroundImage: `url(${SPEEDSIZE_PREFIX}https://www.codere.com.co/colombia/images/seo-ayuda/free-bets-${
            flag ? "mobile" : "desktop"
          }.jpg)`,
          backgroundSize: "cover",
        }}
      ></div>

      <Container>
        <div>
          <h1 className="header mt-4 mb-3">{top_par.h1}</h1>
          {top_par.p.split("\n").map((pi, i) => (
            <p key={i}>{pi}</p>
          ))}
        </div>

        <div id={p1.id}>
          <h2>{p1.h2}</h2>
          <p>{p1.p}</p>
          <div className="px-3">
            {p1.inner.map((inn, i) => (
              <div key={i}>
                <h3>{inn.h3}</h3>
                <p>{inn.p}</p>
              </div>
            ))}
          </div>
        </div>

        <div id={p2.id}>
          <h2 className="mt-4 mb-3">{p2.h2}</h2>
          <p>{p2.p}</p>
          <ol>
            {p2.ol.map((li, i) => {
              if (li.includes("promociones")) {
                const parts = li.split("promociones");
                return (
                  <li key={i}>
                    {parts[0]}
                    <a
                      className="codere-green"
                      rel="nofollow"
                      href="https://m.codere.com.co/deportesCol/#/promociones"
                    >
                      promociones
                    </a>
                    {parts[1]}
                  </li>
                );
              } else {
                return <li key={i}>{li}</li>;
              }
            })}
          </ol>

          <h3>{p2.h3}</h3>
          <p>
            Para realizar las{" "}
            <a
              href="https://m.codere.com.co/deportesCol/#/HomePage"
              rel="nofollow"
            >
              mejores apuestas con las free bets en Codere
            </a>
            , ten en cuenta estos parámetros:
          </p>
          <ul>
            {p2.ul.map((li, i) => {
              let [underline, p] = li.split(":");
              return (
                <li key={i}>
                  <u>{underline}</u>: {p}
                </li>
              );
            })}
          </ul>
        </div>

        <div id={preguntas.id}>
          <h2>{preguntas.h2}</h2>
          <div className="px-3">
            {preguntas.inner.map((inn, i) => (
              <div key={i}>
                <h3>{inn.h3}</h3>
                <p>{inn.p}</p>
              </div>
            ))}
          </div>

          <Button
            href={"https://m.codere.com.co/deportesCol/#/mso/RegistroCONewPage"}
            className="cas-reg-btn"
            rel="nofollow"
          >
            Registrate
          </Button>
        </div>
      </Container>
    </div>
  );
}
